/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Optional approximate listed price metadata from the event provider; not a live offer. Providers report one-sided ranges on dynamically priced events, so a range may carry only a floor or only a ceiling; at least one bound is always present.
 * @export
 * @interface EventPriceRange
 */
export interface EventPriceRange {
    /**
     * Lowest listed price, absent when the provider publishes only a ceiling.
     * @type {number}
     * @memberof EventPriceRange
     */
    minimum?: number;
    /**
     * Highest listed price, absent when the provider publishes only a floor.
     * @type {number}
     * @memberof EventPriceRange
     */
    maximum?: number;
    /**
     * 
     * @type {string}
     * @memberof EventPriceRange
     */
    currency: string;
    /**
     * Provider price basis, for example "standard" or "standard including fees".
     * @type {string}
     * @memberof EventPriceRange
     */
    type?: string;
}

/**
 * Check if a given object implements the EventPriceRange interface.
 */
export function instanceOfEventPriceRange(value: object): value is EventPriceRange {
    if (!('currency' in value) || value['currency'] === undefined) return false;
    return true;
}

export function EventPriceRangeFromJSON(json: any): EventPriceRange {
    return EventPriceRangeFromJSONTyped(json, false);
}

export function EventPriceRangeFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventPriceRange {
    if (json == null) {
        return json;
    }
    return {
        
        'minimum': json['minimum'] == null ? undefined : json['minimum'],
        'maximum': json['maximum'] == null ? undefined : json['maximum'],
        'currency': json['currency'],
        'type': json['type'] == null ? undefined : json['type'],
    };
}

export function EventPriceRangeToJSON(json: any): EventPriceRange {
    return EventPriceRangeToJSONTyped(json, false);
}

export function EventPriceRangeToJSONTyped(value?: EventPriceRange | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'minimum': value['minimum'],
        'maximum': value['maximum'],
        'currency': value['currency'],
        'type': value['type'],
    };
}

